import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { StyledHeaderLayout } from './styles';
import SlideMenu from './SlideMenu/SlideMenuComponent';
import LayoutAction from '../../../../modules/actions/LayoutAction';

const HeaderLayout = (props) => {
  const { hideLayout, history, fullScreen } = props;

  return (
    <span>
      <StyledHeaderLayout
        style={{
          display: hideLayout === true ? 'none' : 'block',
          padding: 0
        }}
      >
        <SlideMenu
          name="test"
          history={history}
          nativProps={props}
          fullScreen={fullScreen}
          {...props}
        />
      </StyledHeaderLayout>
    </span>
  );
};

const mapDispatchToProps = (dispatch) => ({
  LayoutAction: bindActionCreators(LayoutAction, dispatch)
});

export default connect(null, mapDispatchToProps)(HeaderLayout);
